import { ChannelPayloadFilter, ViewStream } from "spyne";

export class CodeContainerExamplesLink extends ViewStream {
  constructor(props = {}) {
    props.class = "code-container-examples-link";
    props.template = require("./templates/code-container-examples-link.tmpl.html");

    super(props);
  }

  addActionListeners() {
    // return nexted array(s)

    const { parentVsid, codeBlockId } = this.props;

    const isCodeBlockIdFilter = new ChannelPayloadFilter({
      payload: (v) => v.codeBlockId === codeBlockId,
    });

    return [
      [
        "CHANNEL_CODE_CONTAINER_UPDATE_EVENT",
        "onDisposeViewStream",
        isCodeBlockIdFilter,
      ],
    ];
  }

  onDisposeViewStream(p) {
    this.disposeViewStream(p);
  }

  broadcastEvents() {
    // return nexted array(s)
    return [["button", "click"]];
  }

  onRendered() {
    this.addChannel("CHANNEL_CODE_CONTAINER", true);
  }
}
